// @flow
import React from "react";
import LazyLoad from "react-lazyload";
import _ from "lodash";
import Helper from "../../../helper/Helper";
import I18n from "../../../i18n/I18n";
import { Badge } from "../";
import styles from "./Status.scss";

const Status = props => {
  const { status, reason } = props;

  let statusText = status || "-";

  switch (status.toLowerCase()) {
    case "new":
      statusText = I18n.getText("orders.new");
      break;
    case "fulfilledfromstock":
      statusText = I18n.getText("orders.fulfilledfromstock");
      break;
    case "readyforpickup":
      statusText = I18n.getText("orders.ready-for-pickup");
      break;
    case "closed":
      statusText = I18n.getText("transfers.closed");
      break;
    case "accepted":
      statusText = I18n.getText("orders.accepted");
      break;
    case "rerequested":
      statusText = I18n.getText("orders.rerequested");
      break;
    case "shipped":
      statusText = I18n.getText("orders.shipped");
      break;
    case "completed":
    case "complete":
      statusText = I18n.getText("orders.completed");
      break;
    case "picked":
      statusText = I18n.getText("orders.picked");
      break;
    case "received":
      statusText = I18n.getText("orders.received");
      break;
    case "rejectedbynoon":
      statusText = I18n.getText("orders.reject-by-noon");
      break;
    case "acceptedbynoon":
      statusText = I18n.getText("orders.accepted-noon");
      break;
    case "cancelledbybuyer":
      statusText = I18n.getText("orders.buyer-cancelled");
      break;
    case "rejected":
      statusText = I18n.getText("orders.rejected");
      break;
    case "dispatched":
      statusText = I18n.getText("transfers.dispatched");
      break;
    case "open":
      statusText = I18n.getText("transfers.open");
      break;
    case "incomplete":
      statusText = I18n.getText("transfers.incomplete");
      break;
    case "pickedup":
      statusText = I18n.getText("transfers.picked-up");
      break;
    case "processing":
      statusText = I18n.getText("transfers.processing");
      break;
    case "scheduled":
      statusText = I18n.getText("transfers.scheduled");
      break;
    case "cancelled":
      statusText = I18n.getText("orders.cancelled");
      break;
    case "returnedbycustomer":
      statusText = I18n.getText("orders.returned-by-customer");
      break;
    case "not_processed":
      statusText = I18n.getText("product.not-processed");
      break;
    case "processed":
      statusText = I18n.getText("transfers.processed");
      break;
    case "not_unique":
      statusText = I18n.getText("product.not-unique");
      break;
    case "invalid_format":
      statusText = I18n.getText("product.invalid-format");
      break;
    case "error":
      statusText = I18n.getText("product.error");

      break;
    default:
      statusText = status;
  }

  return (
    <div
      className={`${styles.status} ${
        status
          ? styles[
              status
                .toLowerCase()
                .split(" ")
                .join("_")
            ]
          : ""
      }`}
    >
      {statusText}
    </div>
  );
};

export default Status;



// WEBPACK FOOTER //
// ./src/components/common/status/Status.js